import React from 'react'

function Footer() {
  return (
    <footer style={{padding:'15px 0'}}>
        <center>Subhajit Nandi $copy:{new Date().getFullYear()}</center>

    </footer>
  )
}

export default Footer